export async function auth() {
  let result = await fetch('https://auth.misis.club/api/v1/whoami', {
        method: 'GET',
        headers: {'Authorization': getCookie('token')}
      });
  let data = await result.json();
  if (data.success) {
    var ret = {
      authorized: true,
      name: data.name,
      email: data.email
    }
    if (data.telegram) ret.telegram = data.telegram;
    if (data.telegramUrl) ret.telegramUrl = data.telegramUrl;
    return ret;
  }
  else {return {authorized: false}}
}

export async function getInitiatives() {
  let result = await fetch('https://change.misis.club/api/v1/getInitiatives', {
    method: 'GET',
    headers: {'Authorization': getCookie('token')}
    });
  let data = await result.json();
  if (data.success) {return data.initiatives}
  else {return undefined}
}

export async function getInitiative(id) {
  let result = await fetch('https://change.misis.club/api/v1/getInitiative?' + new URLSearchParams({id: id}), {
    method: 'GET',
    headers: {'Authorization': getCookie('token')}
    });
  let data = await result.json();
  if (data.success) {return data.initiative}
  else {return undefined}
}

export async function sendChoice(iid, choice){
  let result = await fetch('https://change.misis.club/api/v1/' + choice, {
    method: 'POST',
    headers: {'Authorization': getCookie('token'), 'Content-Type': 'application/json'},
    body: JSON.stringify({
      initiativeId: iid,
    })
    });
  let data = await result.json();
  return data.success;
}

export async function vote(iid) {return await sendChoice(iid, 'vote');}
export async function retract(iid) {return await sendChoice(iid, 'retract');}

export async function createInitiative(title, short, long) {
  let result = await fetch('https://change.misis.club/api/v1/createInitiative', {
    method: 'POST',
    headers: {'Authorization': getCookie('token'), 'Content-Type': 'application/json'},
    body: JSON.stringify({
      title: title,
      short: short,
      long: long
    })
    });
  let data = await result.json();
  return data.success;
}

function extractId(){
  var url = window.location.href;
  var result = url.match(/https?:\/\/[a-z0-9.:]*\/[a-z]*\/([a-f0-9-]*)\/?$/);
  if (!result) {return undefined}
  return result[1];
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/; domain=misis.club";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
